import { render, staticRenderFns } from "./CityPlace.vue?vue&type=template&id=610d7c9b&scoped=true&"
import script from "./CityPlace.vue?vue&type=script&lang=js&"
export * from "./CityPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610d7c9b",
  null
  
)

export default component.exports